import { FC, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, CardHeader, Grid, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@material-ui/core';
import { GetUserProductResponse } from 'src/interfaces/userProduct/user-product';
import { VerifiedStatus } from 'src/enums/common';
import { AddProduct } from '../customers/customerView/dialogs/addProductDetails';

interface ProductDetailsProps {
  userId?: string;
  productsList: GetUserProductResponse[];
  enableRaiseRequest: boolean;
  updateProductState?: () => void;
  setProduct?: (data: GetUserProductResponse) => void;
}

export const UserProductsListCard: FC<ProductDetailsProps> = (props) => {
  const { userId, setProduct, productsList, updateProductState, enableRaiseRequest } = props;
  const [openAddProductDialog, setOpenAddProductDialog] = useState(false);
  const [productId, setProductId] = useState<string>('');

  return (
    <>
      <Card
        variant="outlined"
        sx={{ mt: 1 }}
      >
        <CardHeader
          title="Product Details"
          action={(
            <>
              <Button
                size="small"
                variant="contained"
                onClick={() => setOpenAddProductDialog(true)}
              >
                Add
              </Button>
            </>
          )}
        />
        {productsList.length > 0 && (
        <CardContent
          sx={{
            pt: 1
          }}
        >
          <Grid
            container
          >
            <Grid
              item
              md={12}
              sm={12}
              xs={12}
            >
              <TableContainer
                sx={{
                  maxHeight: '205px',
                  mt: 1,
                  border: 1,
                  borderColor: '#e1e3ea',
                  borderRadius: '2px',
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                >
                  <TableHead>
                    <TableRow
                      key="productDetails"
                    >
                      {enableRaiseRequest && (
                        <TableCell
                          sx={{
                            backgroundColor: 'neutral.100',
                          }}
                        >
                          Select
                        </TableCell>
                      )}
                      <TableCell
                        sx={{
                          backgroundColor: 'neutral.100',
                        }}
                      >
                        Product Nick Name
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: 'neutral.100',
                        }}
                      >
                        Product Name
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: 'neutral.100',
                        }}
                      >
                        Product Type
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: 'neutral.100',
                        }}
                      >
                        Brand
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productsList?.map((detail) => (
                      <TableRow
                        hover
                        key={detail.id}
                      >
                        {enableRaiseRequest && (
                          <TableCell
                            padding="checkbox"
                          >
                            { detail.status === VerifiedStatus.ACTIVE && (
                            <Radio
                              size="small"
                              checked={productId === detail.id}
                              onClick={() => {
                                setProduct(detail);
                              }}
                              onChange={() => setProductId(detail.id)}
                            />
                            )}
                          </TableCell>
                        )}
                        <TableCell>
                          {detail.nickName || '--'}
                        </TableCell>
                        <TableCell>
                          {detail.product?.name}
                        </TableCell>
                        <TableCell>
                          {detail.productType}
                        </TableCell>
                        <TableCell>
                          {detail.brand?.name}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </CardContent>
        )}
      </Card>
      {openAddProductDialog && (
      <AddProduct
        userId={userId}
        open={openAddProductDialog}
        onClose={() => setOpenAddProductDialog(false)}
        setProductState={updateProductState}
      />
      )}
    </>
  );
};

UserProductsListCard.propTypes = {
  userId: PropTypes.string,
  productsList: PropTypes.array,
  enableRaiseRequest: PropTypes.bool,
  updateProductState: PropTypes.func,
  setProduct: PropTypes.func,
};
